module.exports = __webpack_public_path__ + "static/placeholder-94d554d12570028757a965d527d9c9ae.jpg";